import { useEffect, useState } from 'react';

import { BugTracker } from 'kb-shared/utilities/bugTracker';

export const useSvg = (svgUrl: string, width = 48, height = 48) => {
  const [svg, setSvg] = useState<string | null>(null);

  useEffect(() => {
    fetch(svgUrl)
      .then(res => res.text())
      .then(text => {
        const modifiedSvg = text
          .replace(/width="[^"]*"/, `width="${width}px"`)
          .replace(/height="[^"]*"/, `height="${height}px"`);
        setSvg(modifiedSvg);
      })
      .catch(error => BugTracker.notify(error, 'Failed to load SVG'));
  }, [svgUrl, width, height]);

  return svg;
};
